<section
  [formGroup]="shiftForm"
  class="modal-edit-container"
  style="padding: 20px"
>
  <h3 class="modal-header">
    {{ "front.edit-shift-modal.edit-shift" | translate }}
  </h3>

  <div class="picker-content">
    <div>
      <p>{{ "front.edit-shift-modal.start-to" | translate }}</p>
      <ngb-timepicker formControlName="startTime" />
    </div>
    <div>
      <p>{{ "front.edit-shift-modal.finish-to" | translate }}</p>
      <ngb-timepicker formControlName="endTime" />
    </div>
  </div>
  <div class="modal-body text-center">
    <div class="d-flex gap-1 align-items-center justify-content-center">
      <cancel-btn (click)="handleCancel()"></cancel-btn>
      <save-btn
        [label]="'front.save-btn.save-changes'"
        (click)="handleSubmit()"
      >
      </save-btn>
    </div>
  </div>
</section>
